// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"592":"course","745":"learning"}[chunkId] + "." + {"592":"b9948a0f","745":"6bcf7f0e"}[chunkId] + ".js";
};